import { Helmet } from 'react-helmet';

export function PageTitle({ title }) {
  return (
    <Helmet>
      <title>{title} | Pomiechowska Biblioteka Historii Mówionej</title>
    </Helmet>
  );
}
